module.exports = __webpack_public_path__ + "img/poster_3.6422736d.jpg";